const _ = require('lodash');

function InfiniteScrollDirective($window, $) {
    return {
        restrict: 'A',
        scope: {
            onPageDown: '&', // show be a promise
            padding: '@?'
        },
        link(scope, element) {

            let loading = false;
            const isWindow = (element.css('overflow-y') === 'visible');
            const container = isWindow ? $($window) : $(element);
            const padding = (!scope.padding) ? 0 : parseInt(scope.padding, 10);

            function loadNextPage() {
                loading = true;
                scope.onPageDown().then(() => {
                    loading = false;
                });
            }

            function observeScroll() {
                let topHeight = 0;
                if (element.outerHeight() === 0) return; // ng-repeat has not finished in this instance

                if ($('html').hasClass('touchevents')) {
                  const bodyContainer = $('#body-container');
                  topHeight = isWindow ? Math.abs(bodyContainer.offset().top) : element.offset().top;
                } else {
                  topHeight = isWindow ? container.scrollTop() : element.offset().top;
                }

                const totalHeight = Math.ceil(topHeight + container.outerHeight());

                if (!loading && (totalHeight + padding) >= element.outerHeight()) {
                    loadNextPage();
                }
            }

            function registerScrollListeners(eventName, func) {
                return () => {
                    container[eventName]('scroll', func);
                    container[eventName]('wheel', func);
                    container[eventName]('mousewheel', func);
                    container[eventName]('touchmove', func);
                    container[eventName]('keydown', func);
                };
            }

            const debouncedScroll = _.debounce(observeScroll, 150, { leading: true, trailing: true });
            const bindListeners = registerScrollListeners('bind', debouncedScroll);
            const unbindListeners = registerScrollListeners('unbind', debouncedScroll);

            scope.$on('$destroy', unbindListeners);

            bindListeners();
        }
    };
}


module.exports = InfiniteScrollDirective;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/infinate-scroll/infinite-scroll-directive.js
 **/